<template>
  <div id="confirmar-identidade">
    <div v-if="!isJornadaCompleta">
      <h1 class="titulo">Vamos tirar uma foto do seu rosto pra sua segurança no app</h1>
    </div>
    <div v-if="isJornadaCompleta">
      <h1 class="titulo">Vamos confirmar sua identidade pra sua segurança no app</h1>
      <p class="subtitulo w-75 w-lg-100 w-xl-100 w-xxl-100 m-0" >Precisamos tirar uma foto do seu rosto e de um documento </p>
    </div>


    <div class="check-termos">
      <p class="subtitulo mb-4">DICAS IMPORTANTES</p>
      <div class="container">
        <div class="row">
          <div class="col-1 p-0 d-flex align-items-center justify-content-center">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M11.9991 2.25C15.3416 2.25 17.2491 4.08871 17.2491 7.5C17.2491 10.9113 15.3416 12.75 11.9991 12.75C8.74025 12.75 6.8454 11.0021 6.75269 7.75289L6.74912 7.5L6.75269 7.24711C6.8454 3.99792 8.74025 2.25 11.9991 2.25ZM11.9991 3.75C9.47303 3.75 8.24912 4.92973 8.24912 7.5C8.24912 10.0703 9.47303 11.25 11.9991 11.25C14.5252 11.25 15.7491 10.0703 15.7491 7.5C15.7491 4.92973 14.5252 3.75 11.9991 3.75Z" fill="#0B2739"/>
              <path d="M16.1881 14.2551H7.76812C5.27246 14.2551 3.25012 16.2774 3.25012 18.7731V20.9961C3.25012 21.4098 3.58546 21.7451 3.99912 21.7451H19.9991C20.3783 21.7451 20.6917 21.4633 20.7413 21.0977L20.748 20.988L20.707 18.7592C20.7071 16.2776 18.6839 14.2551 16.1881 14.2551ZM7.76812 15.7531H16.1881C17.7971 15.7531 19.1121 17.0102 19.204 18.5956L19.236 20.247H4.74802L4.74812 18.7731C4.74812 17.1048 6.09978 15.7531 7.76812 15.7531Z" fill="#0B2739"/>
            </svg>
          </div>
          <div class="col-11">
            <p class="check-termos-titulo">Deixe seu rosto visível</p>
            <p class="check-termos-sub-titulo">Sem acessórios que encubram o rosto, como óculos, chapéus ou máscaras</p>
          </div>
        </div>
        <div class="row border-top">
          <div class="col-1 p-0 d-flex align-items-center justify-content-center">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M11.3011 4.20545C11.3039 4.54719 11.5841 4.8245 11.9258 4.8217C12.2703 4.8217 12.5476 4.54719 12.5504 4.20825V2.77128C12.5504 2.42954 12.2703 2.15503 11.9258 2.15503C11.5813 2.15503 11.3011 2.42954 11.3011 2.77128V4.20545ZM17.6177 11.0122C17.6177 5.87492 13.3095 5.44074 12.2031 5.41833C12.0322 5.40993 11.839 5.40993 11.6653 5.40993C10.5308 5.41833 6.31234 5.80489 6.31234 10.9814C6.31234 13.5948 7.39918 14.9954 8.61767 15.7349L8.62607 16.8497C8.62607 17.3623 8.77733 17.7601 9.07705 18.0234C9.36276 18.2811 9.79974 18.4127 10.9678 18.4127H12.965C14.1611 18.4127 14.5953 18.2811 14.881 18.0234C15.1751 17.7601 15.3207 17.3623 15.3207 16.8497L15.3123 15.7293C16.5308 14.9842 17.6177 13.5948 17.6177 11.0122ZM16.3684 11.0122C16.3684 12.7741 15.8081 13.9758 14.6541 14.6816C14.6541 14.6816 14.0602 15.043 14.0686 15.043L14.0714 15.7349L14.0799 16.8469C14.0799 16.9309 14.0714 17.015 14.049 17.0962C13.9594 17.1242 13.6905 17.1774 12.9706 17.1774H10.9734C10.2507 17.1774 9.99302 17.1186 9.91178 17.0934C9.90058 17.0654 9.87817 16.9898 9.87817 16.8385L9.86416 15.043L9.27313 14.6872C8.13587 13.9982 7.56164 12.7517 7.56164 10.9842C7.56164 7.22786 10.1359 6.65363 11.6709 6.64523H11.7073C11.8558 6.64523 12.0182 6.64523 12.1751 6.65083C15.9594 6.73206 16.3684 9.72926 16.3684 11.0122ZM11.5925 7.28668C13.5 7.3287 15.6037 8.39312 15.7549 11.2587C15.7717 11.6004 15.5056 11.8889 15.1639 11.9057H15.1303C14.7997 11.9085 14.528 11.6508 14.5084 11.3231C14.3796 8.84691 12.3992 8.53598 11.556 8.51917C11.5081 8.51798 11.4596 8.51832 11.4109 8.51866C11.3457 8.51912 11.28 8.51958 11.2143 8.51637C10.8726 8.51918 10.5925 8.24186 10.5897 7.90013C10.5897 7.55839 10.8698 7.28388 11.2143 7.28388C11.3376 7.28388 11.4748 7.28388 11.5925 7.28668ZM15.3151 19.5248C15.3151 19.1858 15.035 18.9085 14.6905 18.9085H9.39638C9.05184 18.9085 8.77173 19.183 8.77173 19.5248C8.77453 19.8665 9.05464 20.1438 9.39638 20.141H14.6905C15.035 20.141 15.3151 19.8665 15.3151 19.5248ZM13.9762 20.6088C14.3207 20.6088 14.6009 20.8861 14.6009 21.2251C14.6009 21.5668 14.3207 21.8413 13.9762 21.8413H9.951C9.60926 21.8441 9.32915 21.5668 9.32635 21.2251C9.32635 20.8833 9.60646 20.6088 9.951 20.6088H13.9762ZM17.0294 6.47156C16.8642 6.47156 16.7073 6.40713 16.5897 6.29228C16.3488 6.05699 16.346 5.67044 16.5813 5.42954L16.5897 5.42114L17.6149 4.40433C17.8586 4.16343 18.2535 4.16343 18.4972 4.40433C18.7381 4.64242 18.7409 5.02898 18.5028 5.26988L18.4972 5.27548L17.4692 6.28948C17.3544 6.40713 17.1947 6.47156 17.0294 6.47156ZM6.30114 6.46875C6.54484 6.70965 6.93979 6.70965 7.18349 6.46875L7.18909 6.46315C7.42719 6.22226 7.42439 5.8357 7.18349 5.59761L6.15828 4.5808C5.91178 4.3399 5.51963 4.3399 5.27593 4.5808L5.26753 4.5892C5.03223 4.8301 5.03503 5.21946 5.27593 5.45475L6.30114 6.46875ZM5.05744 10.1074C5.40198 10.1074 5.68209 10.3847 5.68209 10.7237C5.68209 11.0654 5.40198 11.3399 5.05744 11.3399H3.60646C3.26472 11.3427 2.98461 11.0654 2.98181 10.7237C2.98181 10.3819 3.26192 10.1074 3.60646 10.1074H5.05744ZM21.0266 10.6508C21.0266 10.3091 20.7465 10.0346 20.402 10.0346H18.951C18.6065 10.0346 18.3263 10.3091 18.3263 10.6508C18.3292 10.9926 18.6093 11.2699 18.951 11.2671H20.402C20.7465 11.2671 21.0266 10.9926 21.0266 10.6508Z" fill="black"/>
            </svg>
          </div>
          <div class="col-11">
            <p class="check-termos-titulo">Fique num lugar com boa iluminação</p>
            <p class="check-termos-sub-titulo">Sem pessoas ou objetos ao fundo</p>
          </div>
        </div>
      </div>

    </div>
    <div id="footer" class="footer-shadow">
      <p>Ao continuar, você aceita nossos <span v-on:click="goTermoUso()">termos de uso</span></p>
      <button type="button" v-on:click="nextPage()" class="btn btn-primary btn-lg btn-block">Continuar</button>
    </div>

  </div>
</template>

<script>
import AppService from "../../services/AppService";
import DispatchTags from "../../utils/DispatchTags";
import WebViewBridgeService from "../../services/WebViewBridgeService";

export default {
  name: "ConfirmarIdentidade",
  data: function (){
    return {
      aceitou: false
    }
  },
  computed:{
    isDisable:function (){
      return this.aceitou
    },
    isJornadaCompleta:function (){
      return  (this.$store.getters.tipoCaptura === 1 && this.$store.getters.indApiN1 !== 1)
    }
  },
  mounted() {
    this.$nextTick(() => {
      let webviewBrige = new WebViewBridgeService();
      webviewBrige.updateNavigationBar();
    });
    this.$store.dispatch('setLoadingStatus',false);
    this.$store.dispatch('setTitulo','Confirmar identidade');
    this.appSerice  = new AppService();
    this.appSerice.carregarComponentSelefie();
    DispatchTags.dispatchScreenView("ConfirmarIdentidade");

    if(this.$store.getters.tipoCaptura === 1 || this.$store.getters.indApiN1 === 1){
      this.appSerice.carregarComponenteDocumento();
    }
  },
  methods:{
    goTermoUso:function (){
      DispatchTags.dispatchInraction('ConfirmarIdentidadeNoneTermsOfUse');
      this.$router.push({name: 'TermoUso'});
    },
    nextPage:function (){
      DispatchTags.dispatchInraction('ConfirmarIdentidadeStartTermsOfUse');
      this.$router.push({name: this.appSerice.getRouteNameSelfie()});
    }
  }
}
</script>

<style scoped>
.check-termos p.subtitulo{
  font-size: 0.75rem;
}
.check-termos p.check-termos-titulo{
  font-size: 1rem;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  font-feature-settings: 'clig' off, 'liga' off;
}
.check-termos .border-top p.check-termos-titulo{
  margin-top: 10px;
}
.check-termos p.check-termos-sub-titulo{
  font-size: 0.875rem;
  color: rgba(102, 102, 102, 1);
  margin-bottom: 10px;
}
#confirmar-identidade{
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-top: 80px;
}
.check-termos{
  margin-top: 2.5rem;
}
.check-termos p{
  margin: 0;
}

.border-top{
  border-top: 0.5px solid #f0f0f0;
}

#footer p{
  font-size: 0.875rem;
  color: rgba(102, 102, 102, 1);
  text-align: center;
}

#footer p span{
  color: var(--general-brand, #609);
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
}

/*@media screen and (max-width: 640px){*/
/*  .check-termos p.check-termos-titulo{*/
/*    font-size: 0.9rem;*/
/*  }*/
/*  .check-termos p.check-termos-sub-titulo{*/
/*    font-size: 0.775rem;*/
/*  }*/
/*}*/

</style>



// WEBPACK FOOTER //
// src/components/pages/ConfirmarIdentidade.vue